
import Hero1 from '../components/VinculaTusFinanzas/Hero1';
import Section2 from '../components/VinculaTusFinanzas/Section2';
import Section3 from '../components/VinculaTusFinanzas/Section3';
import Section4 from '../components/VinculaTusFinanzas/Section4';
import Section5 from '../components/VinculaTusFinanzas/Section5';
import Section6 from '../components/VinculaTusFinanzas/Section6';
import HorizontalList from '../components/horizontalList';

function VinculaTusFinanzas() {
    return (
        <div>

            <Hero1 />
            <HorizontalList items={["Inicio", "Beneficios", "¿Cómo funciona?", "¿Cómo revocar y consultar?", "Política TRD", "Preguntas frecuentes"]} />
            <Section2 />
            <Section3 />
            <Section4 />
            <Section5 />
            <Section6 />
        </div>
    );
}

export default VinculaTusFinanzas;
